import colors from 'sass-extract-loader?{"plugins": ["sass-extract-js"]}!../../scss/app/base/_colors.scss'

export default { ...colors }
